import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { PlannerMenu } from '../oldPlanner/PlannerMenu';
import './Partitions.scss';
import { usePartitionsData } from 'hooks/usePartitionsData';
import { Region } from 'types/orderTypes';
import { PartitionsWrapper } from './PartitionsWrapper';
import { useHistory, useLocation, useParams } from 'react-router-dom';

interface PartitionsProps {
  region: Region;
}

export const Partitions = ({ region, ...props }: PartitionsProps) => {
  const today = dayjs().format('YYYY-MM-DD');
  const params = useParams<{ date?: string }>();
  const history = useHistory();
  const location = useLocation();

  const [activeDate, setActiveDate] = useState<string>(params.date || today);

  const partitionsData = usePartitionsData(activeDate, region);

  /* Date changes */
  const onDateChanged = (date: string) => {
    history.replace(`/planner/partitions/${date}`);
    setActiveDate(date);
  };

  useEffect(() => {
    if (!params.date && activeDate !== today) {
      setActiveDate(today);
    }
  }, [activeDate, today, params.date, location]);

  return (
    <>
      <Helmet>
        <title>Partitions</title>
      </Helmet>
      <PlannerMenu />
      {!partitionsData.isFetching && (
        <PartitionsWrapper
          region={region}
          activeDate={activeDate}
          today={today}
          couriers={partitionsData.couriers}
          partitionList={partitionsData.list}
          zoneCount={partitionsData.zoneCount}
          zoneRatings={partitionsData.zoneRatings}
          onDateChanged={onDateChanged}
          refreshData={partitionsData.refresh}
        />
      )}
    </>
  );
};
